import {
  Component,
  ElementRef,
  HostListener,
  inject,
  OnInit,
  Renderer2,
  viewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  Observable,
  pipe,
  Subscription,
  throwError,
  UnaryFunction,
} from 'rxjs';
import { catchError, finalize, takeUntil, tap } from 'rxjs/operators';
import { TableColumnStateService } from './../../../../shared/global/dynamic-table/table-column-state.service';

import { ApolloError } from '@apollo/client/errors';
import { TranslateService } from '@ngx-translate/core';
import { PageNames } from 'src/app/configs/page-names.enum';
import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import {
  ComparisonOperator,
  CustomResult,
  CustomResultOfGetScheduledMessageByIdDto,
  FailureCode,
  GetEnumValuesDto,
  GetPhonebookRecipientByScheduledMessageIdDto,
  LogicalComparisonOperator,
  PaginatedListOfGetUsersQueueWithPaginationDto,
  SendSubTypes,
  SendTypes,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ScheduledMessagesGQLService } from 'src/app/core/graphql/scheduled-messages-gql.service';
import { ConsoleService } from 'src/app/core/services/console.service';
import { DefaultSearchValueService } from 'src/app/core/services/default-search-value.service';
import { ScheduledMessageIdsStorageService } from 'src/app/core/services/scheduled-message-ids-storage.service';
import { AppSendSmsDialog } from 'src/app/core/types/app-send-sms-dialog.type';
import { TabsDynamicComponent } from 'src/app/layout/components/tabs-dynamic/tabs-dynamic.component';
import { VoiceSmsDetailModalComponent } from 'src/app/shared/components/shortcut-sms-detail/voice-sms-detail-modal/voice-sms-detail-modal.component';
import { GetBulkScheduledMessageByIdDto } from '../../../../core/api/models/get-bulk-scheduled-message-by-id-dto';
import { PaginatedListOfGetCurrentUserQueueWithPaginationDto } from '../../../../core/api/models/paginated-list-of-get-current-user-queue-with-pagination-dto';
import { PaginatedListOfGetUserQueueWithPaginationDto } from '../../../../core/api/models/paginated-list-of-get-user-queue-with-pagination-dto';
import { QueueStatus } from '../../../../core/api/models/queue-status';
import { DateTimeService } from '../../../../core/services/date-time.service';
import { AppDomService } from '../../../../core/services/dom.service';
import { EditSendP2pSmsComponent } from '../../../sending-system/send-p2p-sms/edit-send-p2p-sms/edit-send-p2p-sms.component';
import { DeliveryStatusStats } from '../../shared/delivery-status-stats/delivery-status-stats.component';
import { GetScheduledMessageByIdDto } from './../../../../core/api/models/get-scheduled-message-by-id-dto';
import {
  ScheduledMessagesService,
  SmartSmsRecipientsService,
  VoiceMessagesService,
} from './../../../../core/api/services';
import { OutboxMessageNumbersService } from './../../../../core/api/services/outbox-message-numbers.service';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { DynamicTabService } from './../../../../core/services/dynamic-tab.service';
import { BaseIndexPageComponent } from './../../../../pages/shared/base/components/base-index-page.component';
import { EditDynamicSendSmsComponent } from './../../../sending-system/dynamic-send-sms/edit-dynamic-send-sms/edit-dynamic-send-sms.component';
import { GetSmartSendRequestIdDialog } from './base-send-get-smart-sms-request-id/get-smart-sms-request-id';
import { SendQueueColumnNames } from './columns';

@Component({
  selector: 'app-base-send-queue',
  templateUrl: './base-send-queue.component.html',
  styleUrls: ['../../base/base-report.component.scss'],
  standalone: false,
})
export class BaseSendQueueComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region properties
  scheduledMessagesGQLService = inject(ScheduledMessagesGQLService);

  pageName = PageNames.sendQueue;

  showExportItems: boolean = true;
  innerWidth: number;
  modelWithPagination$: Observable<
    | PaginatedListOfGetCurrentUserQueueWithPaginationDto
    | PaginatedListOfGetUserQueueWithPaginationDto
    | PaginatedListOfGetUsersQueueWithPaginationDto
  >;
  items$: Observable<Array<any>>;
  formPageConfig: FormPageConfig<GetScheduledMessageByIdDto> = {};
  sendBalkFormPageConfig: FormPageConfig<GetBulkScheduledMessageByIdDto> = {};
  sendBalk2FormPageConfig: FormPageConfig<GetBulkScheduledMessageByIdDto> = {};

  pageTitle: string;
  tabName: string;
  isShowOrganizationSearch: boolean = false;
  showReseller: boolean = true;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.innerWidth = window.innerWidth;
  }

  isShowDetail: boolean = false;
  isShowSendBulkDetail: boolean = false;
  isShowPhonebookRecipientInDetail: boolean = false;
  isShowSmartRecipientInDetail: boolean = false;
  isShowPhonebookRecipient: boolean = false;
  isShowOutboxMessageNumbersAuditPage: boolean = false;

  scheduledMessageId: number = 0;
  detailModel: GetScheduledMessageByIdDto;
  formInputModel: any;
  selectedWaitingForConfirmIds: any[] = [];
  organizationId: number;
  selectedPhonebooks: GetPhonebookRecipientByScheduledMessageIdDto[];
  selectedMessage: string | null = null;

  //حالت های مجاز ویرایش یا حذف
  removeOrUpdateStatuses = [
    QueueStatus.Stored,
    QueueStatus.FailedExtract,
    QueueStatus.Failed,
    QueueStatus.WatingForConfirm,
    QueueStatus.Rejected,
    QueueStatus.Updating,
  ];
  dynamicData: GetScheduledMessageByIdDto = {};

  get SendTypes() {
    return SendTypes;
  }
  get QueueStatus() {
    return QueueStatus;
  }
  get FailureCode() {
    return FailureCode;
  }
  get SendSubTypes() {
    return SendSubTypes;
  }
  get PageNames() {
    return PageNames;
  }

  FailureCodeEnumValues: GetEnumValuesDto[] = [];
  QueueStatusEnumValues: GetEnumValuesDto[] = [];
  SendSubTypesEnumValues: GetEnumValuesDto[] = [];
  SendTypesEnumValues: GetEnumValuesDto[] = [];
  DeliveryStatusEnumValues: GetEnumValuesDto[] = [];
  CreationLocationEnumValues: GetEnumValuesDto[] = [];

  subscription: Subscription;

  // برای پاس دادن به کامپوننت داینامیک تیبل که دکمه پاک کردن فیلترها اینارو استثنا قرار بده
  defaultFilters = [
    {
      field: 'dateTimeNext',
      operator: 3,
      value: DateTimeService.getTodayDate().toUTC(),
    },
    {
      field: 'dateTimeNext',
      operator: 4,
      value: DateTimeService.getSimpleTodayDate().toUTC(),
    },
  ];

  columnNames = SendQueueColumnNames;
  selectedFields: string[] = [];
  fixedFields: string[] = [
    this.columnNames.id,
    this.columnNames.smsText,
    this.columnNames.dateTimeNext,
  ];

  graphQlPipeOperators = <T>() =>
    pipe(
      catchError((error: ApolloError) => {
        if (error.graphQLErrors && error.graphQLErrors.length > 0) {
          const errors = error?.graphQLErrors;
          const messages = errors?.map((err) => {
            return errors?.length == 1 ? err.message : '• ' + err.message;
          });
          const msgFormatted = messages.join('<br>');
          this.openErrorMsgDialog({ message: msgFormatted });
        } else this.openErrorMsgDialog({ message: error as any });
        this.cd.detectChanges();
        this.loading = false;
        return throwError(() => error);
      })
    ) as UnaryFunction<Observable<T>, Observable<T>>;

  //#endregion

  constructor(
    protected currentService: ScheduledMessagesService,
    public outboxMessageNumbersService: OutboxMessageNumbersService,
    public OutboxMessageNumbersService: OutboxMessageNumbersService,
    private dynamicTabService: DynamicTabService,
    protected translate: TranslateService,
    private scheduledMessageIdsStorageService: ScheduledMessageIdsStorageService,
    private defaultSearchValueService: DefaultSearchValueService,
    protected smartSmsRecipientsService: SmartSmsRecipientsService,
    protected voiceMessageService: VoiceMessagesService,
    public dialog: MatDialog,
    private renderer: Renderer2,
    protected tabsDynamicComponent: TabsDynamicComponent
  ) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit(false, false);
      this.getUserState();

      if (this.isShowOrganizationSearch) {
        window.scroll(0, 0);
        this.getUserState();
        this.getEnumsValues();
        this.getVocabs();
        this.configTableColumns();
        this.initTablePagination();
        this.configPage();
        this.configFormPage();
      }
      this.pageConfig.title = this.pageTitle;

      if (window.location.search == '') {
        this.setDefaultDateSearch();
        this.setDefaultTableSort();
      }

      this.pageConfig.tableConfig.pageTagName = this.tagName;
      this.pageId = this.tabName;

      this.setPageAfterEnterUrl();

      this.pageConfig.isAddBtnWithLoading = false;
      this.pageConfig.tableConfig.isSticky = true;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  ngAfterViewChecked(): void {
    this.innerWidth = window.innerWidth;
  }

  // وارد میشود چک میکنیم که کدام جدول باید نمایش داده شود url زمانی که کاربر با
  setPageAfterEnterUrl() {
    //  super.setPageAfterEnterUrl();
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      switch (key) {
        case QueryStringTypesEnum.Details_key:
          this.onDetail(
            value.toString().split('_')[0],
            +value.toString().split('_')[1],
            false
          );
          break;
        case QueryStringTypesEnum.Update_key:
          this.onUpdateWithStatus(
            +value.toString().split('_')[0],
            +value.toString().split('_')[1],
            +value.toString().split('_')[2],
            false
          );
          break;
      }
    }
  }

  //#region init

  getEnumsValues() {
    this.getEnumValuesApi('SendSubTypes').subscribe(
      (values) => (this.SendSubTypesEnumValues = values)
    );
    this.getEnumValuesApi('QueueStatus').subscribe(
      (values) => (this.QueueStatusEnumValues = values)
    );
    this.getEnumValuesApi('SendTypes').subscribe(
      (values) => (this.SendTypesEnumValues = values)
    );
    this.getEnumValuesApi('FailureCode').subscribe(
      (values) => (this.FailureCodeEnumValues = values)
    );
    this.getEnumValuesApi('DeliveryStatus')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.DeliveryStatusEnumValues = values));
    this.getEnumValuesApi('EntityCreationLocation')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.CreationLocationEnumValues = values));
  }

  configTableColumns() {
    this.tableVocabs = this.pageVocabs + 'fields.';
    this.tableColumns = [
      {
        title: ``,
        name: '',
        hasSearch: false,
        noSorting: true,
        isCheckBox: true,
        wrap: true,
        isSticky: true,
      },
      {
        title: `${this.tableVocabs}id`,
        name: this.columnNames.id,
        hasSearch: true,
        type: 'number',
        wrap: true,
        noNumberSeparator: true,
        isSticky: true,
      },
      {
        title: this.localizer.smsText,
        name: this.columnNames.smsText,
        hasSearch: true,
        wrap: true,
        isSticky: true,
        customOperators: [
          ComparisonOperator.StartsWith,
          ComparisonOperator.NotEqualTo,
          ComparisonOperator.EqualTo,
          ComparisonOperator.Contains,
          ComparisonOperator.EndsWith,
        ],
      },
      {
        title: this.localizer.resellerName,
        name: this.columnNames.resellerName,
        noSorting: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}recipientCount`,
        name: this.columnNames.recipientCount,
        hasSearch: true,
        type: 'number',
        wrap: true,
      },
      {
        title: this.localizer.senderNumber,
        name: this.columnNames.senderNumber,
        hasSearch: true,
        wrap: true,
        dir: 'ltr',
        customOperators: [
          ComparisonOperator.StartsWith,
          ComparisonOperator.NotEqualTo,
          ComparisonOperator.EqualTo,
          ComparisonOperator.Contains,
          ComparisonOperator.EndsWith,
        ],
      },
      {
        title: this.localizer.sendType,
        name: this.columnNames.sendType,
        hasSearch: true,
        type: 'enum',
        enumName: 'SendTypes',
        wrap: true,
      },
      {
        title: `${this.tableVocabs}campaign`,
        name: this.columnNames.title,
        hasSearch: true,
        wrap: true,
        customOperators: [
          ComparisonOperator.StartsWith,
          ComparisonOperator.NotEqualTo,
          ComparisonOperator.EqualTo,
          ComparisonOperator.Contains,
          ComparisonOperator.EndsWith,
        ],
      },
      {
        title: this.localizer.organization,
        name: this.columnNames.organizationName,
        hasSearch: true,
        wrap: true,
        customOperators: [
          ComparisonOperator.StartsWith,
          ComparisonOperator.NotEqualTo,
          ComparisonOperator.EqualTo,
          ComparisonOperator.Contains,
          ComparisonOperator.EndsWith,
        ],
      },
      {
        title: this.localizer.user,
        name: this.columnNames.userName,
        hasSearch: true,
        wrap: true,
        customOperators: [
          ComparisonOperator.StartsWith,
          ComparisonOperator.NotEqualTo,
          ComparisonOperator.EqualTo,
          ComparisonOperator.Contains,
          ComparisonOperator.EndsWith,
        ],
      },

      {
        title: this.localizer.sendSubType,
        name: this.columnNames.sendSubType,
        hasSearch: true,
        type: 'enum',
        enumName: 'SendSubTypes',
        wrap: true,
      },
      {
        title: this.localizer.status,
        name: this.columnNames.status,
        hasSearch: true,
        type: 'enum',
        enumName: 'QueueStatus',
        wrap: true,
      },
      {
        title: `${this.tableVocabs}failureCode`,
        name: this.columnNames.failureCode,
        hasSearch: true,
        type: 'enum',
        enumName: 'FailureCode',
        wrap: true,
      },
      {
        title: 'common.creationLocation',
        name: this.columnNames.creationLocation,
        hasSearch: true,
        type: 'enum',
        enumName: 'EntityCreationLocation',
        wrap: true,
      },
      {
        title: 'common.voiceMessage',
        name: this.columnNames.voiceMessageId,
        type: 'boolean',
        hasSearch: false,
        noSorting: true,
      },
      {
        title: this.localizer.description,
        name: this.columnNames.description,
        hasSearch: true,
        wrap: true,
        customOperators: [
          ComparisonOperator.StartsWith,
          ComparisonOperator.NotEqualTo,
          ComparisonOperator.EqualTo,
          ComparisonOperator.Contains,
          ComparisonOperator.EndsWith,
        ],
      },
      {
        title: this.localizer.createDate,
        name: this.columnNames.created,
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
        disableResize: true,
      },
      {
        title: 'common.sentDateTime',
        name: this.columnNames.dateTimeNext,
        hasSearch: true,
        type: 'dateTime',
        dateDefaultValue: DateTimeService.getTodayDate().toUTC(),
        defaultDateType:
          this.tabName == PageNames.currentUserSendQueue ? 'startDate' : 'both',
        wrap: true,
        isSticky: true,
        order: 99,
      },
    ];

    if (!this.showReseller)
      this.tableColumns = this.tableColumns.filter(
        (obj) => obj.name !== this.columnNames.resellerName
      );
  }

  setDefaultTableSort() {
    const isExistsSortObject = this.sortObject.some((item) =>
      item.columnName.includes(this.columnNames.dateTimeNext)
    );

    if (!isExistsSortObject)
      this.sortObject.push({
        columnName: this.columnNames.dateTimeNext,
        sort: 1,
      });
  }

  setDefaultDateSearch() {
    try {
      let greaterThan = {
        field: 'dateTimeNext',
        operator: 3,
        value: DateTimeService.getTodayDate().toUTC(),
      };
      let lessThan = {
        field: 'dateTimeNext',
        operator: 4,
        value: DateTimeService.getSimpleTodayDate().toUTC(),
      };
      this.comparisonObjects.push({
        comparisonObjects: [greaterThan, lessThan],
        logicalComparisonOperator: LogicalComparisonOperator.And,
      });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  onClearQueryString() {
    this.tabsDynamicComponent.refreshTab(this.tabName);
  }

  //#endregion

  //#region api

  setSelectedFields() {
    this.selectedFields = [];
    this.selectedFields = Object.assign([], this.fixedFields);
    const data = TableColumnStateService.getData(this.tagName);
    let allHaveIsHide: boolean = false;
    if (data)
      allHaveIsHide = Object.values(data).every(
        (item: any) => 'isHide' in item
      );
    if (data && allHaveIsHide) {
      Object.keys(data).forEach((key) => {
        if (!data[key]?.isHide) this.selectedFields.push(key);
      });
    } else this.selectedFields = Object.values(this.columnNames);

    if (!this.showReseller)
      this.selectedFields = this.selectedFields.filter(
        (s) => s !== this.columnNames.resellerName
      );
  }

  //Delete
  baseDeleteApi(id: number) {
    this.unSubs();
    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;

    this.currentService
      .scheduledMessagesDelete({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }

  //Update (Check Scheduled Message Status For Edit)
  checkScheduledMessageStatusForEditApi(
    id: number,
    sendType?: SendTypes,
    status?: QueueStatus,
    setUrl: boolean = true
  ) {
    this.unSubs();
    this.pageConfig.loading = true;

    this.currentService
      .scheduledMessagesUpdateScheduledMessageStatusForEdit({
        body: { id: id },
      })
      .pipe(this.basePipeOperators())
      .subscribe((result: any) => {
        if (result.isSucceed)
          this.baseUpdateGetApi(id, sendType, status, setUrl);

        if (!result.isSucceed)
          this.apiNotificationService.notifyMessage({ result });
      });
  }

  //Get scheduledMessages By Id
  baseGetByIdApi(id: number, sendType?: SendTypes): void {
    this.unSubs();
    this.pageConfig.loading = true;

    this.currentService
      .scheduledMessagesGetScheduledMessageById({ ScheduledMessageId: id })
      .pipe(this.basePipeOperators())
      .subscribe((res: CustomResultOfGetScheduledMessageByIdDto) => {
        try {
          this.detailModel = res.data;

          if ([SendTypes.Bulk, SendTypes.Bulk2].includes(res.data?.sendType))
            this.isShowSendBulkDetail = true;
          else if (
            [SendTypes.Phonebook, SendTypes.Dynamic, SendTypes.Club].includes(
              res.data?.sendType
            )
          ) {
            this.isShowDetail = true;
            this.isShowPhonebookRecipientInDetail = true;
          } else if (res.data?.sendType == SendTypes.Smart) {
            this.isShowDetail = true;
            this.isShowSmartRecipientInDetail = true;
          } else this.isShowDetail = true;
        } catch (error) {
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.smsReport
          );
        }
      });
  }

  baseUpdateGetApi(
    id: number,
    sendType?: SendTypes,
    status?: QueueStatus,
    setUrl: boolean = true
  ) {
    try {
      let updateGetApiMethodName: string = '';
      let paramIdName: string = 'ScheduledMessageId';

      switch (sendType) {
        case SendTypes.Single:
          updateGetApiMethodName = 'scheduledMessagesUpdateGet';
          break;
        case SendTypes.Bulk:
          updateGetApiMethodName =
            'scheduledMessagesUpdateScheduledMessageBulkGet';
          paramIdName = 'id';
          break;
        case SendTypes.Bulk2:
          updateGetApiMethodName =
            'scheduledMessagesUpdateScheduledMessageBulkGet';
          paramIdName = 'id';
          break;
        case SendTypes.Dynamic:
          updateGetApiMethodName =
            'scheduledMessagesUpdateDynamicScheduledMessageGet';
          break;
        case SendTypes.P2P:
          updateGetApiMethodName =
            'scheduledMessagesUpdateP2PScheduledMessageGet';
          break;
        case SendTypes.Phonebook:
          updateGetApiMethodName =
            'scheduledMessagesUpdateScheduledMessageByPhonebookGet';
          break;
        case SendTypes.SmartP2P:
          updateGetApiMethodName = 'scheduledMessagesUpdateGet';
          break;
        case SendTypes.Smart:
          updateGetApiMethodName = 'scheduledMessagesUpdateGet';
          break;
        default:
          return;
          break;
      }

      this.unSubs();
      this.pageConfig.loading = true;
      this.currentService[updateGetApiMethodName]({ [paramIdName]: id })
        .pipe(this.basePipeOperators())
        .pipe(
          tap((res: CustomResultOfGetScheduledMessageByIdDto) => {
            this.selectedPhonebooks = res?.data
              ?.phonebookRecipients as GetPhonebookRecipientByScheduledMessageIdDto[];
          })
        )
        .subscribe((res) => {
          if (res?.data) {
            if (sendType == SendTypes.Dynamic) {
              this.dynamicData = res?.data;
              // this.openEditSendSmsDialog(res?.data, 'dynamic');
              // return;
              this.formPageConfig.editData = res?.data;
              this.formPageConfig.editId = id;
              this.formPageConfig.isEditMode = true;
              this.pageConfig.isVisibleForm = true;

              this.showParent = false;
              this.setParentQueryString();
              if (setUrl) {
                this.location.go(
                  window.location.pathname +
                    '?' +
                    QueryStringTypesEnum.Update_key +
                    '=' +
                    id +
                    '_' +
                    sendType +
                    '_' +
                    status
                );
              }
              return;
            }
            if (
              sendType == SendTypes.P2P ||
              res?.data.sendType == SendTypes.ApiP2P
            ) {
              this.openEditSendSmsDialog(res?.data, 'p2p');
              return;
            }
            if (sendType == SendTypes.Bulk) {
              this.sendBalkFormPageConfig.editData = res?.data;
              this.sendBalkFormPageConfig.editId = id;
              this.sendBalkFormPageConfig.isEditMode = true;
              this.pageConfig.isVisibleForm = true;

              this.showParent = false;
              this.setParentQueryString();
              if (setUrl) {
                this.location.go(
                  window.location.pathname +
                    '?' +
                    QueryStringTypesEnum.Update_key +
                    '=' +
                    id +
                    '_' +
                    sendType +
                    '_' +
                    status
                );
              }
              return;
            }

            if (sendType == SendTypes.Bulk2) {
              this.sendBalk2FormPageConfig.editData = res?.data;
              this.sendBalk2FormPageConfig.editId = id;
              this.sendBalk2FormPageConfig.isEditMode = true;
              this.pageConfig.isVisibleForm = true;

              this.showParent = false;
              this.setParentQueryString();
              if (setUrl) {
                this.location.go(
                  window.location.pathname +
                    '?' +
                    QueryStringTypesEnum.Update_key +
                    '=' +
                    id +
                    '_' +
                    sendType +
                    '_' +
                    status
                );
              }
              return;
            }

            this.formPageConfig.editData = res?.data;
            this.formPageConfig.editId = id;
            this.formPageConfig.isEditMode = true;
            this.pageConfig.isVisibleForm = true;

            this.showParent = false;
            this.setParentQueryString();
            if (setUrl) {
              this.location.go(
                window.location.pathname +
                  '?' +
                  QueryStringTypesEnum.Update_key +
                  '=' +
                  id +
                  '_' +
                  sendType +
                  '_' +
                  status
              );
            }
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  //resend
  resendScheduledMessageApi(ids: number[]) {
    this.unSubs();
    this.pageConfig.loading = true;

    this.currentService
      .scheduledMessagesResendScheduledMessage({ body: { ids: ids } })
      .pipe(
        this.basePipeOperators(),
        tap((res) => {
          if (res?.isSucceed) {
            this.selectedIds = [];
            this.unCheckSelectedItems();
          }
        })
      )
      .subscribe(this.baseObserver);
  }

  //Group deletion
  deleteScheduledMessagesByIdListApi(ids: number[]) {
    this.unSubs();
    this.pageConfig.loading = true;
    this.lastSelectedItemId = ids;

    this.currentService
      .scheduledMessagesDeleteList({ body: { ids: ids } })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.selectedIds = [])),
        tap((res) => {
          if (res?.isSucceed) this.selectedIds = [];
        })
      )
      .subscribe(this.baseGroupDeleteObserver);
  }

  confirmScheduledMessageStatusApi(scheduledMessageId: number) {
    this.unSubs();
    this.pageConfig.loading = true;
    if (scheduledMessageId)
      this.selectedWaitingForConfirmIds.push(scheduledMessageId);

    this.currentService
      .scheduledMessagesConfirmScheduledMessageStatus({
        body: { scheduledMessageIds: this.selectedWaitingForConfirmIds },
      })
      .pipe(this.basePipeOperators())
      .subscribe(
        (result: CustomResult) => {
          this.apiNotificationService.notifyMessage({ result });
          if (result.isSucceed) {
            this.selectedWaitingForConfirmIds = [];
            this.selectedIds = [];
            this.getTableData();
            this.unCheckSelectedItems();
          }
        },
        (error) => {
          this.selectedWaitingForConfirmIds = [];
          this.selectedIds = [];
          ConsoleService.error('error', error);
        },
        () => (this.pageConfig.loading = false)
      );
  }

  rejectScheduledMessageStatusApi(scheduledMessageId: number) {
    this.unSubs();
    this.pageConfig.loading = true;
    if (scheduledMessageId)
      this.selectedWaitingForConfirmIds.push(scheduledMessageId);

    this.currentService
      .scheduledMessagesRejectScheduledMessage({
        body: { scheduledMessageIds: this.selectedWaitingForConfirmIds },
      })
      .pipe(this.basePipeOperators())
      .subscribe(
        (result: CustomResult) => {
          this.apiNotificationService.notifyMessage({ result });
          if (result.isSucceed) {
            this.selectedWaitingForConfirmIds = [];
            this.selectedIds = [];
            this.getTableData();
            this.unCheckSelectedItems();
          }
        },
        (error) => {
          ConsoleService.error('error', error);
        },
        () => (this.pageConfig.loading = false)
      );
  }

  userConfirmScheduledMessageStatusApi(scheduledMessageId: number) {
    this.unSubs();
    this.pageConfig.loading = true;

    this.currentService
      .scheduledMessagesUserConfirmScheduledMessageStatus({
        body: {
          scheduledMessageId: scheduledMessageId,
        },
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //ارسال نظیر به نظیر را مجدد به صف پردازش اضافه میکند
  addP2PToQueueApi(scheduledMessageId: number) {
    this.unSubs();
    this.pageConfig.loading = true;

    this.currentService
      .scheduledMessagesAddP2PScheduledMessageToQueue({
        body: { scheduledMessageId: scheduledMessageId },
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //ارسال تکی فایلی را مجدد به صف پردازش اضافه میکند
  addScheduledMessageToQueueApi(scheduledMessageId: number) {
    this.unSubs();
    this.pageConfig.loading = true;

    this.currentService
      .scheduledMessagesAddScheduledMessageToFileSendQueue({
        body: { scheduledMessageId: scheduledMessageId },
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  getShortcutDetailModelApi(smsText: string, voiceMessageId: number) {
    try {
      let detailGetApiMethodName: string = '';
      let paramIdName: string = 'id';
      if (voiceMessageId) {
        detailGetApiMethodName = 'voiceMessagesUpdateUploadedFileGet';
      }

      this.unSubs();
      this.pageConfig.loading = true;
      this.voiceMessageService[detailGetApiMethodName]({
        [paramIdName]: voiceMessageId,
      })
        .pipe(this.basePipeOperators())
        .subscribe((res) => {
          if (res?.isSucceed) {
            if (voiceMessageId) {
              this.openShortcutDetail(smsText, res?.data);
              return;
            }
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  //#endregion

  //#region Resend

  onSingleResend(scheduledMessageId: number) {
    try {
      if (!scheduledMessageId) return;
      this.scheduledMessageId = scheduledMessageId;
      this.groupResendConfirmation([scheduledMessageId]);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  callGroupResendApi(ids?: number[]) {
    this.resendScheduledMessageApi(ids);
    this.cd.detectChanges();
  }

  //#endregion

  //#region add p2p to queue
  onAddP2PToQueue(scheduledMessageId: number) {
    try {
      if (!scheduledMessageId) return;
      this.addP2PToQueue(scheduledMessageId);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  addP2PToQueue(scheduledMessageId: number) {
    const dialogResult = this.getConfirmDialog({
      title: 'messages.addToQueue',
      content: scheduledMessageId.toString(),
      isConfirmDelete: false,
      wordBreak: false,
    });

    dialogResult
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result) => {
        if (result) this.addP2PToQueueApi(scheduledMessageId);
      });
  }

  //#endregion

  //#region add scheduled message to queue
  onAddScheduleMessageToQueue(scheduledMessageId: number) {
    try {
      if (!scheduledMessageId) return;
      this.AddScheduleMessageToQueue(scheduledMessageId);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  AddScheduleMessageToQueue(scheduledMessageId: number) {
    const dialogResult = this.getConfirmDialog({
      title: 'messages.addToQueue',
      content: scheduledMessageId.toString(),
      isConfirmDelete: false,
      wordBreak: false,
    });

    dialogResult
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result) => {
        if (result) this.addScheduledMessageToQueueApi(scheduledMessageId);
      });
  }
  //#endregion

  //#region group Deletion
  callGroupDeletion() {
    this.deleteScheduledMessagesByIdListApi(this.selectedIds);
    this.cd.detectChanges();
  }
  //#endregion

  //#region Edit Dialog

  openEditSendSmsDialog(
    model: GetScheduledMessageByIdDto,
    type: AppSendSmsDialog
  ) {
    try {
      this.unSubs();

      let data = {
        model: {
          id: model.id,
          privateNumberId: model.privateNumberId,
          dateTimeNext: model.dateTimeNext,
          description: model.description,
        },
      };

      const modalResult = this.dialogService.openModal({
        component:
          type == 'dynamic'
            ? EditDynamicSendSmsComponent
            : EditSendP2pSmsComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  //#endregion

  //#region on Show

  onShowReceivers(id: number, created: string, sendType?: SendTypes) {
    this.showParent = false;
    this.setParentQueryString();
    try {
      this.scheduledMessageId = id;
      this.defaultSearchValueService.defaultDateValue = created;
      if (
        [
          SendTypes.Dynamic,
          SendTypes.P2P,
          SendTypes.ApiP2P,
          SendTypes.SmartP2P,
          SendTypes.OccasionPhonebook,
        ].includes(sendType)
      ) {
        this.scheduledMessageIdsStorageService.scheduledMessageIds.push(id);
        this.dynamicTabService.setNewTab('');
        this.dynamicTabService.setNewTab(
          'dynamicSendReceivers?' +
            QueryStringTypesEnum.ScheduledMessage_key +
            '=' +
            id
        );
        this.dynamicTabService.setActiveTab(
          'dynamicSendReceivers?' +
            QueryStringTypesEnum.ScheduledMessage_key +
            '=' +
            id
        );
      } else {
        this.scheduledMessageIdsStorageService.scheduledMessageIds.push(id);
        this.dynamicTabService.setNewTab('');
        this.dynamicTabService.setNewTab(
          'sendReceivers?' +
            QueryStringTypesEnum.ScheduledMessage_key +
            '=' +
            id
        );
        this.dynamicTabService.setActiveTab(
          'sendReceivers?' +
            QueryStringTypesEnum.ScheduledMessage_key +
            '=' +
            id
        );
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  onShowPhonebookRecipient(id: number) {
    this.isShowPhonebookRecipient = true;
    this.scheduledMessageId = id;
  }

  onShowOutboxMessageNumbersAuditPage() {
    this.isShowOutboxMessageNumbersAuditPage = true;
  }

  //#endregion

  isRemoveOrUpdateIsAccessible(status: QueueStatus): boolean {
    try {
      if (this.removeOrUpdateStatuses.indexOf(status) > -1) return true;
      else return false;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  isSmartPeriodicSms(sendType: SendTypes, sendSubType: SendSubTypes): boolean {
    return sendType == SendTypes.Smart && sendSubType == SendSubTypes.Periodic;
  }

  goSendSmsPage(tabName: string) {
    try {
      this.dynamicTabService.setNewTab('');
      this.dynamicTabService.setNewTab(tabName);
      this.dynamicTabService.setActiveTab(tabName);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  isErrorStatus(status: QueueStatus): boolean {
    if (
      status == QueueStatus.Failed ||
      status == QueueStatus.FailedExtract ||
      status == QueueStatus.Rejected
    )
      return true;

    return false;
  }

  getSendSubTypesHtmlClass(type: SendSubTypes): string {
    try {
      let classList = '';

      switch (type) {
        case SendSubTypes.Direct:
          classList = 'text-tertiary tw-font-medium';
          break;
        case SendSubTypes.Periodic:
          classList = 'text-warning tw-font-medium';
          break;
        case SendSubTypes.Gradual:
          classList = 'text-info tw-font-medium';
          break;

        default:
          break;
      }

      return classList;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  onDelete(id: any, status: QueueStatus) {
    if (!this.isRemoveOrUpdateIsAccessible(status)) return;

    let dialogResult = this.dialogService.confirmDialog({
      // title: this.translate.instant('common.warning'),
      isConfirmDelete: true,
      content: id,
    });
    dialogResult.afterClosed().subscribe((result) => {
      if (result) {
        this.baseDeleteApi(id);
      }
    });
  }

  onDetail(id, sendType?: SendTypes, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Details_key +
          '=' +
          id +
          '_' +
          sendType
      );
    }
    this.scheduledMessageId = id;
    this.isShowPhonebookRecipientInDetail = false;
    this.isShowSmartRecipientInDetail = false;

    this.baseGetByIdApi(id, sendType);
  }

  onUpdateWithStatus(
    id?: number,
    sendType?: number,
    status?: number,
    setUrl = true
  ): void {
    if (setUrl) if (!this.isRemoveOrUpdateIsAccessible(status)) return;
    this.checkScheduledMessageStatusForEditApi(id, sendType, status, setUrl);
  }

  onConfirmSend(scheduledMessageId?: number) {
    this.confirmScheduledMessageStatusApi(scheduledMessageId);
  }

  onRejectSend(scheduledMessageId?: number) {
    this.selectedWaitingForConfirmIds =
      this.selectedWaitingForConfirmIds.filter(
        (el, i, a) => i === a.indexOf(el)
      );

    const dialogResult = this.getConfirmDialog({
      title: 'messages.rejectSend',
      content: scheduledMessageId
        ? scheduledMessageId.toString()
        : this.selectedWaitingForConfirmIds.join(','),
      isConfirmDelete: false,
      confirmBtnColor: 'btn-danger',
      wordBreak: false,
    });

    dialogResult
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result) => {
        if (result) this.rejectScheduledMessageStatusApi(scheduledMessageId);
      });
  }

  onUserConfirmSend(scheduledMessageId: number) {
    this.userConfirmScheduledMessageStatusApi(scheduledMessageId);
  }

  onAddToJob(scheduledMessageId: number) {
    this.unSubs();
    this.pageConfig.loading = true;
    this.currentService
      .scheduledMessagesAddExistScheduledMessageToJobGet()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) {
          this.addExistScheduledMessageToJob(scheduledMessageId);
        }
      });
  }

  addExistScheduledMessageToJob(scheduledMessageId) {
    this.pageConfig.loading = true;
    this.currentService
      .scheduledMessagesAddExistScheduledMessageToJobPost({
        scheduledMessageId: scheduledMessageId,
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  getFormResponse($event) {
    this.showParent = true;
    this.getParentQueryString();
    super.getFormResponse($event);
    this.formPageConfig = {};
    this.sendBalkFormPageConfig = {};
  }

  async getAllCheckBoxesAsync(): Promise<NodeListOf<Element>> {
    return AppDomService.getElementsByQueryAsync(
      `${this.tabName} [data-checkbox-id]`
    );
  }

  //#region import export smart sms

  readonly importRecepient = viewChild<ElementRef>('importRecepient');

  onExportRecepientClick(scheduledMessageId: number) {
    this.smartSmsRecipientsService
      .smartSmsRecipientsDownloadSmartSmsRecipientPost({
        body: {
          scheduledMessageId: scheduledMessageId,
        },
      })
      .subscribe((exportResult) => {
        const blob = new Blob([exportResult?.data], { type: 'text/plain' });
        let url = window.URL.createObjectURL(blob);
        let a = this.renderer.createElement('a');
        this.renderer.appendChild(document.body, a);
        this.renderer.setStyle(a, 'display', 'none');
        this.renderer.setProperty(a, 'href', url);
        this.renderer.setProperty(
          a,
          'download',
          'smart-recepient-' + scheduledMessageId.toString() + '.txt'
        );
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      });
  }

  importSmartSmsRecepients() {
    const importRecepient = this.importRecepient();
    this.renderer.setProperty(importRecepient.nativeElement, 'value', '');

    // this.importRecepient.nativeElement.value = '';
    importRecepient.nativeElement.click();
  }

  importSartSmsRecepientsFile(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;
    if (fileList) {
      const dialogRef = this.dialog.open(GetSmartSendRequestIdDialog, {
        width: '250px',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result != -1)
          this.smartSmsRecipientsService
            .smartSmsRecipientsCreateSmartSmsRecipientByFilePost({
              body: {
                File: fileList[0],
                SmartSmsRequestId: result,
              },
            })
            .subscribe(this.baseObserver);
      });
    }
  }

  // DeliveryStatusChart
  deliveryStatusChart(scheduledMessageId) {
    // this.unSubs();
    if (this.subscription) this.subscription.unsubscribe();

    this.pageConfig.loading = true;
    this.subscription = this.outboxMessageNumbersService
      .outboxMessageNumbersGetOutboxMessageDeliveryStatusStatisticsByScheduledMessageId(
        {
          body: { scheduledMessageId: scheduledMessageId },
        }
      )
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        try {
          if (res) {
            let data = {
              scheduledMessageId: scheduledMessageId,
              DeliveryStatusEnumValues: this.DeliveryStatusEnumValues,
              deliveryStatusData: res?.data,
            };

            const modalResult = this.dialogService.openModal({
              component: DeliveryStatusStats,
              data: data,
            });

            const sub = modalResult
              .afterClosed()
              .pipe(
                takeUntil(this.onDestroy$),
                tap(() => {
                  AppDomService.removeModalScrollClassFromHtml();
                })
              )
              .subscribe((res) => {
                sub.unsubscribe();
              });
          }
        } catch (error) {
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.smsReport
          );
        }
      });
  }
  //#endregion

  onAddSelectedId(event, selectedItem: any, element) {
    try {
      const checkBoxAllElement =
        this.elementRef.nativeElement.querySelectorAll(`.select-all`);

      let checked = event?.target?.checked;
      if (!selectedItem) return;

      if (checked) {
        this.isSelectAll(checkBoxAllElement);

        if (
          selectedItem.status == QueueStatus.WatingForConfirm &&
          this.currentUserInfo?.organizationIsConfirmMessage
        ) {
          //add
          if (
            this.selectedWaitingForConfirmIds?.find(
              (id) => id === selectedItem.id
            )
          )
            return;
          this.selectedWaitingForConfirmIds?.push(selectedItem.id);
        }
        //add
        if (this.selectedIds?.find((id) => id === selectedItem.id)) return;
        this.selectedIds?.push(selectedItem.id);
        (element as HTMLElement).classList.add('row-active');
      } else {
        if (
          selectedItem.status == QueueStatus.WatingForConfirm &&
          this.currentUserInfo?.organizationIsConfirmMessage
        ) {
          //remove
          const id = this.selectedWaitingForConfirmIds?.findIndex(
            (id) => id === selectedItem.id
          );
          if (id != -1) this.selectedWaitingForConfirmIds?.splice(id, 1);
        }
        //remove
        const id = this.selectedIds?.findIndex((id) => id === selectedItem.id);
        if (id != -1) this.selectedIds?.splice(id, 1);
        (element as HTMLElement).classList.remove('row-active');
        if ((checkBoxAllElement[0] as HTMLInputElement).checked)
          this.unCheckSelectAll();
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  unCheckSelectedItems() {
    try {
      const checkBoxAllElement =
        this.elementRef.nativeElement.querySelectorAll(`.form-check-input`);
      if (checkBoxAllElement)
        checkBoxAllElement.forEach((element) => {
          if (element.checked) element.checked = false;
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  onChangeOrganization(organizationId: number) {
    this.organizationId = organizationId;
    this.getTableData();
  }

  isShowResendBtn(status: QueueStatus): boolean {
    return (
      status != QueueStatus.BeforeAddJob &&
      status != QueueStatus.Extracting &&
      status != QueueStatus.TwentyFivePercentOfExtractingIsDone &&
      status != QueueStatus.FiftyPercentOfExtractingIsDone &&
      status != QueueStatus.SeventyFivePercentOfExtractingIsDone &&
      status != QueueStatus.Extracted
    );
  }

  onDownloadFile(fileLink) {
    const link = document.createElement('a');
    link.href = fileLink;
    link.click();
  }

  openShortcutDetail(smsText: string, model) {
    try {
      this.unSubs();

      let data = {
        model: {
          smsText: smsText,
          content: model,
        },
      };
      const modalResult = this.dialogService.openModal({
        component: VoiceSmsDetailModalComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }
}
